/*
 * Monthly Archive — client-side month filter + pagination for the blog listing (Option B).
 *
 * The archive sidebar lists months derived from article publish dates. Shopify has no
 * native way to filter blog articles by date via URL (only by tag), so we filter on the
 * client: every rendered card carries a data-archive-month="YYYY-MM" attribute, and the
 * archive links carry a matching data-archive-month. Selecting a month shows only the
 * matching cards. Pagination is also client-side (over the same in-DOM card set) so that
 * filtering keeps working — server pagination would only put one page of cards in the DOM.
 *
 * Links are real ?month=YYYY-MM&page=N URLs so deep links and back/forward work.
 *
 * Scope note: filtering/pagination cover the most recent 50 articles (the same window the
 * archive sidebar is built from), since the cards are rendered without server pagination.
 */
(function () {
  var PER_PAGE = 6;
  var CARET =
    '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

  function getParams() {
    var month = '';
    var page = 1;
    try {
      var sp = new URLSearchParams(window.location.search);
      month = sp.get('month') || '';
      page = parseInt(sp.get('page'), 10) || 1;
    } catch (e) {}
    return { month: month, page: page };
  }

  function initSection(root) {
    var grid = root.querySelector('[data-archive-grid]');
    if (!grid) return;

    var articles = Array.prototype.slice.call(grid.querySelectorAll('[data-archive-month]'));

    // data-archive-extra only hides cards via CSS before JS loads (to avoid a flash of all
    // 50 cards). Once JS controls visibility via inline display, strip it — otherwise the
    // CSS rule keeps hiding cards that happen to be beyond the first page.
    articles.forEach(function (a) {
      a.removeAttribute('data-archive-extra');
    });

    var links = Array.prototype.slice.call(root.querySelectorAll('[data-archive-link]'));
    var clearBtn = root.querySelector('[data-archive-clear]');
    var filterBar = root.querySelector('[data-archive-filter-bar]');
    var filterLabel = root.querySelector('[data-archive-filter-label]');
    var paginationEl = root.querySelector('[data-archive-pagination]');
    var emptyMsg = root.querySelector('[data-archive-empty]');

    var isCollage = grid.classList.contains('blog-articles--collage');
    var baseUrl = clearBtn ? clearBtn.getAttribute('href') : window.location.pathname;

    var params = getParams();
    var state = { month: params.month, page: params.page };

    function labelFor(month) {
      for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute('data-archive-month') === month) {
          var lbl = links[i].querySelector('.main-blog__archive-label');
          return lbl ? lbl.textContent.trim() : month;
        }
      }
      return month;
    }

    function buildUrl(month, page) {
      var parts = [];
      if (month) parts.push('month=' + encodeURIComponent(month));
      if (page && page > 1) parts.push('page=' + page);
      return baseUrl + (parts.length ? '?' + parts.join('&') : '');
    }

    function activeList() {
      if (!state.month) return articles;
      return articles.filter(function (a) {
        return a.getAttribute('data-archive-month') === state.month;
      });
    }

    function renderPagination(pages) {
      if (!paginationEl) return;
      if (pages <= 1) {
        paginationEl.innerHTML = '';
        return;
      }

      var html =
        '<nav class="pagination" role="navigation" aria-label="Pagination">' +
        '<ul class="pagination__list list-unstyled" role="list">';

      if (state.page > 1) {
        html +=
          '<li><a href="' + buildUrl(state.month, state.page - 1) +
          '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"' +
          ' data-archive-page="' + (state.page - 1) + '" aria-label="Previous page">' +
          '<span class="svg-wrapper">' + CARET + '</span></a></li>';
      }

      for (var p = 1; p <= pages; p++) {
        if (p === state.page) {
          html +=
            '<li><a role="link" aria-disabled="true"' +
            ' class="pagination__item pagination__item--current light" aria-current="page"' +
            ' aria-label="Page ' + p + '">' + p + '</a></li>';
        } else {
          html +=
            '<li><a href="' + buildUrl(state.month, p) +
            '" class="pagination__item link" data-archive-page="' + p +
            '" aria-label="Page ' + p + '">' + p + '</a></li>';
        }
      }

      if (state.page < pages) {
        html +=
          '<li><a href="' + buildUrl(state.month, state.page + 1) +
          '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"' +
          ' data-archive-page="' + (state.page + 1) + '" aria-label="Next page">' +
          '<span class="svg-wrapper">' + CARET + '</span></a></li>';
      }

      html += '</ul></nav>';
      paginationEl.innerHTML = html;
    }

    function render() {
      links.forEach(function (l) {
        l.classList.toggle(
          'main-blog__archive-link--active',
          !!state.month && l.getAttribute('data-archive-month') === state.month
        );
      });

      // The collage layout spans every 3rd card via :nth-child. It stays correct for the
      // unfiltered view (each page is a contiguous block of 6), but breaks on a sparse
      // (filtered) set — so drop it while a month is active.
      if (isCollage) grid.classList.toggle('blog-articles--collage', !state.month);

      var active = activeList();
      var pages = Math.max(1, Math.ceil(active.length / PER_PAGE));
      if (state.page > pages) state.page = pages;
      if (state.page < 1) state.page = 1;

      var start = (state.page - 1) * PER_PAGE;
      var visible = active.slice(start, start + PER_PAGE);

      articles.forEach(function (a) {
        a.style.display = 'none';
      });
      visible.forEach(function (a) {
        a.style.display = '';
      });

      if (filterBar) filterBar.hidden = !state.month;
      if (filterLabel && state.month) filterLabel.textContent = labelFor(state.month);
      if (emptyMsg) emptyMsg.hidden = active.length !== 0;

      renderPagination(pages);
    }

    function scrollToTop() {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        state.month = link.getAttribute('data-archive-month');
        state.page = 1;
        history.pushState(state, '', buildUrl(state.month, state.page));
        render();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        state.month = '';
        state.page = 1;
        history.pushState(state, '', buildUrl('', 1));
        render();
      });
    }

    if (paginationEl) {
      paginationEl.addEventListener('click', function (e) {
        var link = e.target.closest ? e.target.closest('[data-archive-page]') : null;
        if (!link) return;
        e.preventDefault();
        state.page = parseInt(link.getAttribute('data-archive-page'), 10) || 1;
        history.pushState(state, '', buildUrl(state.month, state.page));
        render();
        scrollToTop();
      });
    }

    window.addEventListener('popstate', function () {
      var p = getParams();
      state.month = p.month;
      state.page = p.page;
      render();
    });

    render();
  }

  function init() {
    var sections = document.querySelectorAll('[data-main-blog]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
